import { campaignConstants } from '../constants';
import { campaignService } from '../../services';

export const campaignActions = {
  campaignsList,
  addCampaign,
  getCampaign,
  updateCampaign
}

/*
ACTION: Campaigns List
*/
function campaignsList(pageID, perPage, searchInput) {
  return dispatch => {
    dispatch(request());
    return campaignService.campaignsList(pageID, perPage, searchInput)
      .then(
        response => {
          dispatch(success(response.data.body.campagnes, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: campaignConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: campaignConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: campaignConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Campaign
*/
function addCampaign(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return campaignService.addCampaign(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: campaignConstants.ADD_REQUEST } }
  function success(status) { return { type: campaignConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: campaignConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Campaign By ID
*/
function getCampaign(addToast, campaignID) {
  return dispatch => {
    dispatch(request());
    return campaignService.getCampaign(campaignID)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: campaignConstants.GET_REQUEST } }
  function success(item) { return { type: campaignConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: campaignConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Campaign
*/
function updateCampaign(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return campaignService.updateCampaign(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: campaignConstants.UPDATE_REQUEST } }
  function success(status) { return { type: campaignConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: campaignConstants.UPDATE_FAILURE, error } }
}